import styled from "styled-components";
import { flexColumn, flexNoneEnd } from "../../styles/mixins.style";
import { ReactComponent as ReservationIcon } from '../../svg/reservation.svg'
import { ReactComponent as KakaoIcon } from '../../svg/kakao.svg'
import { ReactComponent as TopIcon } from '../../svg/top.svg'
import React from "react";

export default function QuickMenu() {
	const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;
	const [mobile, setMobile] = React.useState(isMobile);
	React.useEffect(() => {
		const handleResize = () => setMobile(window.innerWidth <= 768);
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return (
		<QuickMenuWrapper $mobile={mobile}>
			<QuickMenuList $mobile={mobile}>
				{mobile ? (
					<>
						<QuickMenuItem $mobile={mobile}>
							<QuickMenuLink href="http://pf.kakao.com/_DKqwn/chat" target="_blank" $mobile={mobile}>
								<KakaoIcon />
								1:1 채팅
							</QuickMenuLink>
						</QuickMenuItem>
						<QuickMenuItem className="reservation-quick" $mobile={mobile}>
							<QuickMenuLink href="https://booking.naver.com/booking/3/bizes/1405798/items/6725690?area=ple&lang=ko&theme=place" target="_blank" $mobile={mobile}>
								<ReservationIcon />
								예약하기
							</QuickMenuLink>
						</QuickMenuItem>
					</>
				) : (
					<>
						<QuickMenuItem className="reservation-quick" $mobile={mobile}>
							<QuickMenuLink href="https://booking.naver.com/booking/3/bizes/1405798/items/6725690?area=ple&lang=ko&theme=place" target="_blank" $mobile={mobile}>
								<ReservationIcon />
								예약하기
							</QuickMenuLink>
						</QuickMenuItem>
						<QuickMenuItem $mobile={mobile}>
							<QuickMenuLink href="http://pf.kakao.com/_DKqwn/chat" target="_blank" $mobile={mobile}>
								<KakaoIcon />
							</QuickMenuLink>
						</QuickMenuItem>
					</>
				)}
				{!mobile && (
					<TopButton id="top-button" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
						<TopIcon />
					</TopButton>
				)}
			</QuickMenuList>
		</QuickMenuWrapper>
	);
}

const QuickMenuWrapper = styled.div<{ $mobile?: boolean }>`
	position: fixed;
	bottom: 2rem;
	right: 2rem;
	z-index: 1000;
	@media (max-width: 768px) {
		bottom: 0;
		right: 0;
		left: 0;
		width: 100vw;
		background: #000;
		padding: 0;
	}
`;

const QuickMenuList = styled.ul<{ $mobile?: boolean }>`
	${flexColumn}
	${flexNoneEnd}
	gap: 8px;
	@media (max-width: 768px) {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 0;
		width: 100vw;
		justify-content: stretch;
		align-items: stretch;
		border-top: 1px solid #ffffff60;
	}
`;

const QuickMenuItem = styled.li<{ $mobile?: boolean }>`
	color: #000;
	font-family: 'pretendard', Arial, sans-serif;
	background-color: #fff;
	border: 1px solid #666;
	width: 2.5rem;
	height: 2.5rem;
	border-radius: 50%;
	transition: background-color 0.3s ease, color 0.3s ease;
	display: flex;
	align-items: center;
	justify-content: center;
	&.reservation-quick {
		width: fit-content;
		border-radius: 1.25rem;
		padding: 1rem;
		font-size: 0.875rem;
	}
	&:hover {
		color: #fff;
		background-color: #000;
		border-color: #ffffff70;
		svg path {
			fill: #fff;
		}
		a {
			color: #fff;
		}
	}
	@media (max-width: 768px) {
		width: 50vw !important;
		height: 3.5rem;
		border-radius: 0;
		padding: 0;
		background: #000;
		color: #fff;
		border: none;
		font-size: 0.875rem;
		justify-content: center;
		&.reservation-quick {
			border-radius: 0;
			padding: 0;
		}
		&:nth-child(2) {
			border-left: 1px solid #ffffff60;
		}
	}
`;

const QuickMenuLink = styled.a<{ $mobile?: boolean }>`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.25rem;
	svg {
		width: 20px;
		height: 20px;
	}
	@media (max-width: 768px) {
		color: #fff;
		background: #121212;
		font-weight: 500;
		height: 100%;
		gap: 0.5rem;
		svg {
			display: none;
		}
	}
`;

const TopButton = styled(QuickMenuItem)`
	cursor: pointer;
`;